import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface IDatabaseState {
  databaseDetail: IObjectState<any>
}

export const prefix = "database/database"

export const state = (): IDatabaseState => ({
  databaseDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return state.databaseDetail.data || {}
  },
}

export const mutations = {
  updateDetail: (state: IDatabaseState, data) => {
    Vue.set(state, "databaseDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.databaseDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(state.databaseDetail, response.data)
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(state.databaseDetail, e.response?.data || e)
      )
    }
  },
}
